import React from "react";
import stylesSCTree from "../SCTree.module.css";
import {TreeDOMHelper} from "./TreeHelper";
import ReactDOM from "react-dom";
import {TreeAlignmentButtons} from "./documentButtons/TreeAlignmentButtons";

export class TreeScrollableDocument extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            text: ''
        };
    }


    componentDidMount() {
        if (typeof this.props.textToScrollJson !== 'undefined' && this.props.textToScrollJson != null) {
            var markedClass = stylesSCTree["tree-markYellow"];
            var context = TreeDOMHelper.markElementText('#scrollable-document-container', this.props.textToScrollJson.word, markedClass);
            var marked = context.getElementsByClassName(markedClass);
            var count = 0;
            for (var item of marked) {
                if (this.props.textToScrollJson.position !== count) {
                    item.classList.add(stylesSCTree['tree-markYellow-hidden']);
                } else {
                    item.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                        inline: "nearest"
                    });
                }

                if (count === 0) {
                    this.setState({text: item.innerText})
                }
                count++;
            }

            ReactDOM.render(<TreeAlignmentButtons
                    otherFilename={this.props.otherFilename}
                    otherLabel={this.props.otherLabel}
                    projectName={this.props.projectName}
                    parentKey={this.props.parentKey}
                    filename={this.props.filename}
                    isDirect={this.props.isDirect}
                    textToScrollJson={this.props.textToScrollJson}
                    position={typeof this.props.textToScrollJson !== 'undefined' && this.props.textToScrollJson != null ? this.props.textToScrollJson.position : null}
                    markedCount={marked.length}
                    resHtml={this.props.resHtml}/>
                , document.getElementById(this.props.renderFooterElement));
        }
    }

    render() {
        return <div id={'scrollable-document-container'}
                    style={{height: '100%', overflow: 'auto', padding: '4px'}}
                    dangerouslySetInnerHTML={{__html: this.props.resHtml}}/>
    }
}